const ta = {
  nav: {
    home: "முகப்பு",
    salons: "அழகு நிலையங்கள்",
    membership: "உறுப்பினர் திட்டம்",
    shop: "கடை",
    academy: "அகாடமி",
    blog: "ஜர்னல்",
    login: "உள்நுழைவு",
    logout: "வெளியேறு",
    dashboard: "டாஷ்போர்டு",
    bookings: "எனது பதிவுகள்",
    loyalty: "விசுவாசப் புள்ளிகள்",
    profile: "சுயவிவரம்",
    orders: "எனது ஆர்டர்கள்",
    chat: "உரையாடல்கள்",
    notifications: "அறிவிப்புகள்",
    partner: "பங்குதாரர்",
    admin: "நிர்வாகி",
    partner_panel: "பங்குதாரர் பலகம்",
    admin_panel: "நிர்வாக பலகம்",
    login_register: "உள்நுழை / பதிவு செய்",
    skip_to_content: "உள்ளடக்கத்திற்கு செல்",
    account_menu: "கணக்கு மெனு",
    primary_nav: "முதன்மை",
    mobile_nav: "மொபைல் வழிசெலுத்தல்",
    ai_advisor: "AI ஆலோசகர்",
    cart: "ஷாப்பிங் கார்ட்",
  },
  footer: {
    tagline: "இந்தியாவின் பிரீமியம் அழகு நிலைய முன்பதிவு தளம் — ஆடம்பர அழகை உங்கள் விரல் நுனியில்.",
    company: "நிறுவனம்",
    about: "எங்களைப் பற்றி",
    how_it_works: "இது எப்படி செயல்படுகிறது",
    partners: "பங்குதாரர்களுக்கு",
    stylists: "ஸ்டைலிஸ்டுகளுக்கு",
    careers: "வேலை வாய்ப்புகள்",
    contact: "தொடர்பு",
    support: "ஆதரவு",
    faq: "கேள்வி பதில்கள்",
    help: "உதவி மையம்",
    privacy: "தனியுரிமைக் கொள்கை",
    terms: "சேவை விதிமுறைகள்",
    refund: "பணத்திரும்பப் பெறும் கொள்கை",
    services: "சேவைகள்",
    salons: "அழகு நிலையங்கள்",
    membership: "உறுப்பினர் திட்டம்",
    shop: "கடை",
    academy: "அகாடமி",
    connect: "இணையுங்கள்",
    newsletter_title: "எங்கள் செய்திமடலில் இணையுங்கள்",
    newsletter_sub: "அழகு குறிப்புகள், சிறப்பு சலுகைகள், ஸ்பேம் இல்லை.",
    newsletter_placeholder: "உங்கள் மின்னஞ்சல்",
    newsletter_cta: "சந்தா செய்",
    copyright: "© {{year}} Fayriza. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    made_in: "இந்தியாவில் உருவாக்கப்பட்டது",
  },
  home: {
    hero_eyebrow: "இந்தியாவின் பிரீமியம் அழகு நிலைய வலையமைப்பு",
    hero_title: "உங்கள் சரியான அழகு நிலைய அனுபவத்தை கண்டறியுங்கள்",
    hero_subtitle: "உங்களுக்கு அருகிலுள்ள சிறந்த அழகு நிலையங்களில் சந்திப்பை முன்பதிவு செய்யுங்கள் — ஆடம்பரம், வசதி, கவனிப்பு.",
    search_placeholder: "அழகு நிலையங்கள், சேவைகள் அல்லது ஸ்டைலிஸ்டுகளைத் தேடுங்கள்…",
    search_cta: "அழகு நிலையத்தைக் கண்டறி",
    featured_salons: "சிறப்பு அழகு நிலையங்கள்",
    browse_all: "அனைத்தையும் பார்",
    view_all: "அனைத்தையும் காட்டு",
    categories_title: "வகைகளை ஆராயுங்கள்",
    categories_sub: "ஒவ்வொரு சந்தர்ப்பத்திற்கும் தேர்ந்தெடுக்கப்பட்ட சேவைகள்",
    why_title: "ஏன் Fayriza",
    why_sub: "ஆரம்பம் முதல் இறுதி வரை ஒரு பிரீமியம் அனுபவம்",
    why_1_title: "சரிபார்க்கப்பட்ட அழகு நிலையங்கள்",
    why_1_body: "ஒவ்வொரு பங்குதாரர் அழகு நிலையமும் கைதேர்ந்து தரம் சரிபார்க்கப்படுகிறது.",
    why_2_title: "உடனடி முன்பதிவு",
    why_2_body: "நேரடி நேர கிடைக்கும் தன்மை, விநாடிகளில் உறுதி செய்யப்படுகிறது.",
    why_3_title: "பாதுகாப்பான பணம் செலுத்துதல்",
    why_3_body: "Razorpay ஆதரவு, பணத்திரும்பப் பெறும் பாதுகாப்புடன் கூடிய பரிவர்த்தனைகள்.",
    why_4_title: "விசுவாசம் & வெகுமதிகள்",
    why_4_body: "ஒவ்வொரு வருகைக்கும் புள்ளிகள் சம்பாதித்து, சலுகைகளாக மாற்றுங்கள்.",
    testimonials_title: "எங்கள் சமூகத்தின் அன்பைப் பெற்றவர்கள்",
    cta_title: "பிரகாசிக்கத் தயாரா?",
    cta_sub: "ஆயிரக்கணக்கான Fayriza உறுப்பினர்களுடன் இணையுங்கள்.",
    cta_btn: "தொடங்குங்கள்",
  },
  salons: {
    title: "அனைத்து அழகு நிலையங்கள்",
    subtitle: "உங்களுக்கு அருகிலுள்ள பிரீமியம் பங்குதாரர் அழகு நிலையங்களை உலாவுங்கள்",
    filter: "வடிகட்டு",
    sort: "வரிசைப்படுத்து",
    sort_relevance: "பொருத்தமானது",
    sort_rating: "சிறந்த மதிப்பீடு",
    sort_price_asc: "விலை: குறைவு முதல் அதிகம்",
    sort_price_desc: "விலை: அதிகம் முதல் குறைவு",
    sort_nearest: "அருகாமையில்",
    search_placeholder: "பெயர் அல்லது பகுதி மூலம் தேடுங்கள்…",
    categories_all: "அனைத்தும்",
    city_all: "அனைத்து நகரங்கள்",
    price_range: "விலை வரம்பு",
    open_now: "இப்போது திறந்துள்ளது",
    no_results_title: "உங்கள் வடிகட்டிகளுக்கு பொருந்தும் அழகு நிலையங்கள் இல்லை",
    no_results_sub: "வடிகட்டியை அகற்ற முயற்சிக்கவும் அல்லது வேறு பகுதியில் தேடவும்.",
    clear_filters: "வடிகட்டிகளை அழி",
    showing: "{{count}} அழகு நிலையங்கள் காட்டப்படுகின்றன",
    loading: "அழகு நிலையங்கள் ஏற்றப்படுகின்றன…",
    book_now: "இப்போதே முன்பதிவு செய்",
    from: "தொடக்கம்",
    per_service: "ஒரு சேவைக்கு",
    results: "முடிவுகள்",
    filters_title: "வடிகட்டிகள்",
    reset_all: "அனைத்தையும் மீட்டமை",
    category: "வகை",
    min_rating: "குறைந்தபட்ச மதிப்பீடு",
    any_rating: "எந்த மதிப்பீடும்",
    for_gender: "யாருக்காக",
    gender_women: "பெண்கள்",
    gender_men: "ஆண்கள்",
    gender_unisex: "அனைவருக்கும்",
    cat_bridal: "மணமகள்",
    cat_spa: "ஸ்பா",
  },
  salon: {
    book_now: "இப்போதே முன்பதிவு செய்",
    message: "செய்தி",
    favourite: "பிடித்தவை",
    unfavourite: "பிடித்தவையிலிருந்து அகற்று",
    share: "பகிர்",
    directions: "வழிகள்",
    call: "அழை",
    services: "சேவைகள்",
    stylists: "ஸ்டைலிஸ்டுகள்",
    reviews: "மதிப்புரைகள்",
    availability: "கிடைக்கும் நிலை",
    gallery: "கேலரி",
    about: "பற்றி",
    working_hours: "பணி நேரம்",
    amenities: "வசதிகள்",
    contact: "தொடர்பு",
    overview: "கண்ணோட்டம்",
    location: "இருப்பிடம்",
    reviews_count: "{{count}} மதிப்புரைகள்",
    rating_out_of: "5-ல் {{rating}}",
    select_service: "முன்பதிவு செய்ய ஒரு சேவையைத் தேர்ந்தெடுக்கவும்",
    duration: "கால அளவு",
    minutes: "{{min}} நிமிடம்",
    open: "திறந்துள்ளது",
    closed: "மூடப்பட்டுள்ளது",
    closes_at: "{{time}} மணிக்கு மூடப்படும்",
    opens_at: "{{time}} மணிக்கு திறக்கப்படும்",
  },
  booking: {
    title: "சந்திப்பை முன்பதிவு செய்யுங்கள்",
    step_services: "சேவைகள்",
    step_stylist: "ஸ்டைலிஸ்ட்",
    step_datetime: "தேதி & நேரம்",
    step_review: "மதிப்பாய்வு",
    step_pay: "பணம் செலுத்துதல்",
    select_services: "சேவைகளைத் தேர்ந்தெடு",
    select_stylist: "ஸ்டைலிஸ்டைத் தேர்ந்தெடு",
    any_stylist: "கிடைக்கும் எந்த ஸ்டைலிஸ்ட்",
    select_date: "தேதியைத் தேர்ந்தெடு",
    select_time: "நேரத்தைத் தேர்ந்தெடு",
    no_slots: "இந்த தேதிக்கு நேரம் கிடைக்கவில்லை",
    try_other_date: "வேறு தேதியை முயற்சி செய்யவும்",
    confirm: "முன்பதிவை உறுதிப்படுத்து",
    cancel: "முன்பதிவை ரத்து செய்",
    reschedule: "மறுசீரமை",
    subtotal: "துணை மொத்தம்",
    discount: "தள்ளுபடி",
    tax: "வரிகள் & கட்டணங்கள்",
    total: "மொத்தம்",
    pay_now: "இப்போதே பணம் செலுத்து",
    pay_at_salon: "அழகு நிலையத்தில் பணம் செலுத்து",
    use_wallet: "வாலட்டைப் பயன்படுத்து",
    apply_offer: "சலுகையைப் பயன்படுத்து",
    offer_placeholder: "குறியீட்டை உள்ளிடவும்",
    apply: "பயன்படுத்து",
    remove: "அகற்று",
    booking_confirmed: "முன்பதிவு உறுதிசெய்யப்பட்டது!",
    booking_cancelled: "முன்பதிவு ரத்து செய்யப்பட்டது",
    booking_ref: "முன்பதிவு ஐடி",
    when: "எப்போது",
    where: "எங்கே",
    who: "யாருடன்",
    notes: "குறிப்பு சேர் (விருப்பம்)",
    notes_placeholder: "ஒவ்வாமை, விருப்பத்தேர்வுகள்…",
    upcoming: "வரவிருக்கும்",
    past: "கடந்தவை",
    cancelled: "ரத்து செய்யப்பட்டது",
    view_details: "விவரங்களைக் காண்",
    download_receipt: "ரசீதைப் பதிவிறக்கு",
    rate_visit: "இந்த வருகையை மதிப்பிடுங்கள்",
  },
  auth: {
    login_title: "மீண்டும் வரவேற்கிறோம்",
    login_sub: "Fayriza-வைத் தொடர உள்நுழையவும்",
    register_title: "கணக்கை உருவாக்கு",
    register_sub: "இந்தியாவின் பிரீமியம் அழகு நிலைய வலையமைப்பில் இணையுங்கள்",
    email: "மின்னஞ்சல்",
    email_placeholder: "you@example.com",
    password: "கடவுச்சொல்",
    password_placeholder: "குறைந்தது 8 எழுத்துகள்",
    phone: "தொலைபேசி எண்",
    phone_placeholder: "10 இலக்க மொபைல் எண்",
    name: "முழு பெயர்",
    name_placeholder: "உங்கள் பெயர்",
    otp: "OTP உள்ளிடவும்",
    otp_placeholder: "6 இலக்க குறியீடு",
    send_otp: "OTP அனுப்பு",
    verify_otp: "சரிபார்",
    resend_otp: "OTP மீண்டும் அனுப்பு",
    resend_in: "{{s}} வினாடிகளில் மீண்டும் அனுப்பு",
    login_cta: "உள்நுழை",
    register_cta: "கணக்கை உருவாக்கு",
    forgot_password: "கடவுச்சொல் மறந்துவிட்டதா?",
    reset_password: "கடவுச்சொல்லை மீட்டமை",
    reset_sub: "உங்கள் மின்னஞ்சலை உள்ளிடவும், மீட்டமைப்பு இணைப்பை அனுப்புவோம்",
    reset_sent: "மீட்டமைப்பு இணைப்பு உங்கள் மின்னஞ்சலுக்கு அனுப்பப்பட்டது",
    new_password: "புதிய கடவுச்சொல்",
    confirm_password: "கடவுச்சொல்லை உறுதிப்படுத்து",
    social_login: "அல்லது இதன் மூலம் தொடரவும்",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    verify_email: "மின்னஞ்சலை சரிபார்",
    verify_email_sub: "{{email}}-க்கு சரிபார்ப்பு இணைப்பை அனுப்பியுள்ளோம்",
    resend_email: "சரிபார்ப்பு மின்னஞ்சலை மீண்டும் அனுப்பு",
    accept_terms: "விதிமுறைகள் மற்றும் தனியுரிமைக் கொள்கையை ஏற்கிறேன்",
    switch_to_register: "கணக்கு இல்லையா?",
    switch_to_register_cta: "பதிவு செய்",
    switch_to_login: "ஏற்கனவே கணக்கு உள்ளதா?",
    switch_to_login_cta: "உள்நுழை",
    remember_me: "என்னை நினைவில் கொள்",
    phone_or_email: "தொலைபேசி அல்லது மின்னஞ்சல்",
    use_phone: "தொலைபேசியைப் பயன்படுத்து",
    use_email: "மின்னஞ்சலைப் பயன்படுத்து",
  },
  profile: {
    title: "எனது சுயவிவரம்",
    edit_profile: "சுயவிவரத்தைத் திருத்து",
    change_password: "கடவுச்சொல்லை மாற்று",
    avatar: "சுயவிவர படம்",
    upload_photo: "படத்தை பதிவேற்று",
    name: "முழு பெயர்",
    phone: "தொலைபேசி எண்",
    email: "மின்னஞ்சல்",
    dob: "பிறந்த தேதி",
    gender: "பாலினம்",
    gender_male: "ஆண்",
    gender_female: "பெண்",
    gender_other: "மற்றவை",
    address: "முகவரி",
    city: "நகரம்",
    pincode: "அஞ்சல் குறியீடு",
    save: "மாற்றங்களைச் சேமி",
    saved: "சுயவிவரம் புதுப்பிக்கப்பட்டது",
    current_password: "தற்போதைய கடவுச்சொல்",
    current_password_placeholder: "தற்போதைய கடவுச்சொல்லை உள்ளிடவும்",
    new_password: "புதிய கடவுச்சொல்",
    new_password_placeholder: "குறைந்தது 8 எழுத்துகள்",
    password_changed: "கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது",
  },
  dashboard: {
    title: "டாஷ்போர்டு",
    welcome: "மீண்டும் வரவேற்கிறோம், {{name}}",
    upcoming_bookings: "வரவிருக்கும் முன்பதிவுகள்",
    no_upcoming: "வரவிருக்கும் சந்திப்புகள் இல்லை",
    book_a_salon: "அழகு நிலையத்தை முன்பதிவு செய்",
    favourites: "பிடித்த அழகு நிலையங்கள்",
    no_favourites: "இதுவரை எந்த அழகு நிலையத்தையும் பிடித்தவையாகச் சேர்க்கவில்லை",
    loyalty_points: "விசுவாசப் புள்ளிகள்",
    wallet_balance: "வாலட் இருப்பு",
    recent_activity: "சமீபத்திய செயல்பாடு",
    quick_actions: "விரைவு செயல்கள்",
    view_all: "அனைத்தையும் காட்டு",
    manage_membership: "உறுப்பினர் திட்டத்தை நிர்வகி",
    top_up_wallet: "வாலட்டை நிரப்பு",
    refer_friend: "நண்பரைப் பரிந்துரை",
  },
  common: {
    loading: "ஏற்றப்படுகிறது…",
    error: "ஏதோ தவறு நடந்துள்ளது",
    retry: "மீண்டும் முயற்சி",
    no_results: "முடிவுகள் இல்லை",
    search: "தேடு",
    filter: "வடிகட்டு",
    sort: "வரிசைப்படுத்து",
    view_all: "அனைத்தையும் காட்டு",
    see_more: "மேலும் காண்",
    see_less: "குறைவாகக் காண்",
    back: "பின்",
    next: "அடுத்து",
    previous: "முந்தையது",
    submit: "சமர்ப்பி",
    cancel: "ரத்து",
    delete: "நீக்கு",
    edit: "திருத்து",
    save: "சேமி",
    close: "மூடு",
    confirm: "உறுதிப்படுத்து",
    continue: "தொடர்",
    yes: "ஆம்",
    no: "இல்லை",
    skip: "தவிர்",
    optional: "விருப்பம்",
    required: "அவசியம்",
    from: "இலிருந்து",
    per: "ஒரு",
    to: "வரை",
    and: "மற்றும்",
    or: "அல்லது",
    learn_more: "மேலும் அறிய",
    coming_soon: "விரைவில் வருகிறது",
    currency: "₹",
    minutes_short: "நிமி",
    hours_short: "மணி",
    km: "கி.மீ",
    away: "தூரம்",
    stars: "நட்சத்திரங்கள்",
  },
  loyalty: {
    title: "Fayriza விசுவாசம்",
    subtitle: "ஒவ்வொரு வருகைக்கும் புள்ளிகள் சம்பாதியுங்கள், வெகுமதிகளாக மாற்றுங்கள்",
    points: "புள்ளிகள்",
    available_points: "கிடைக்கும் புள்ளிகள்",
    total_earned: "மொத்தம் சம்பாதித்தது",
    total_redeemed: "மொத்தம் மீட்டது",
    redeem: "மீட்டெடு",
    history: "புள்ளிகள் வரலாறு",
    rewards: "வெகுமதிகள்",
    tier: "அடுக்கு",
    how_it_works: "இது எப்படி செயல்படுகிறது",
    earn_title: "சம்பாதி",
    earn_body: "செலவழிக்கும் ஒவ்வொரு ₹10-க்கும் 1 புள்ளி. Gold-இல் 2×, Platinum-இல் 3×.",
    redeem_title: "மீட்டெடு",
    redeem_body: "வாலட் கிரெடிட், இலவச சேவைகள் அல்லது பங்குதாரர் சலுகைகளுக்கு புள்ளிகளைப் பயன்படுத்துங்கள்.",
    empty_history: "இதுவரை புள்ளி செயல்பாடு இல்லை",
    empty_rewards: "இப்போது எந்த வெகுமதிகளும் கிடைக்கவில்லை",
  },
  wallet: {
    title: "Fayriza வாலட்",
    subtitle: "ஒரே முறை நிரப்பி, தடையின்றி முன்பதிவு செய்யுங்கள்",
    balance: "இருப்பு",
    available: "கிடைக்கிறது",
    topup: "நிரப்பு",
    topup_cta: "பணம் சேர்",
    topup_amount: "தொகை",
    history: "பரிவர்த்தனை வரலாறு",
    empty_history: "இதுவரை பரிவர்த்தனைகள் இல்லை",
    credit: "கிரெடிட்",
    debit: "டெபிட்",
    refund: "பணத்திரும்பப் பெறல்",
  },
  membership: {
    eyebrow: "பிரத்யேக அணுகல்",
    hero_title: "Fayriza உறுப்பினர் திட்டங்கள்",
    hero_sub: "இந்தியா முழுவதும் உள்ள 500+ பிரீமியம் அழகு நிலையங்களில் பிரத்யேக தள்ளுபடிகள், முன்னுரிமை முன்பதிவு மற்றும் ஆடம்பர சலுகைகளைத் திறக்கவும்.",
    plans: "உறுப்பினர் திட்டங்கள்",
    subscribe: "சந்தா செய்",
    cancel: "உறுப்பினர் திட்டத்தை ரத்து செய்",
    current: "தற்போதைய திட்டம்",
    gold: "Gold",
    silver: "Silver",
    platinum: "Platinum",
    per_year: "/ஆண்டு",
    per_month_approx: "≈ ₹{{amount}}/மாதம்",
    cancel_anytime: "எந்த நேரத்திலும் ரத்து செய்யலாம்",
    choose_title: "உங்கள் திட்டத்தைத் தேர்ந்தெடு",
    choose_sub: "அனைத்து திட்டங்களும் ஆண்டு அடிப்படையில் கட்டணம் வசூலிக்கப்படும். ஒரு திட்டத்தைத் தேர்ந்தெடுத்து உடனடியாக செயல்படுத்த உறுதிப்படுத்தவும்.",
    most_popular: "மிகவும் பிரபலமானது",
    get_plan: "{{plan}} பெறு",
    selected_proceed: "தேர்ந்தெடுக்கப்பட்டது — பணம் செலுத்த தொடரவும் →",
    processing: "செயலாக்கப்படுகிறது…",
    current_plan_label: "✓ தற்போதைய திட்டம்",
    welcome_back: "மீண்டும் வரவேற்கிறோம், {{name}}!",
    member_label: "Fayriza {{tier}} உறுப்பினர்",
    expires_in: "{{days}} நாட்களில் காலாவதியாகும்",
    renews_on: "{{date}} அன்று புதுப்பிக்கப்படும்",
    your_discount: "உங்கள் தள்ளுபடி",
    off_all: "அனைத்து சேவைகளிலும் தள்ளுபடி",
    expiring_warn: "உங்கள் உறுப்பினர் திட்டம் விரைவில் காலாவதியாகிறது. உங்கள் தள்ளுபடிகளைத் தக்கவைக்க இப்போதே புதுப்பிக்கவும்.",
    feature_comparison: "முழுமையான அம்ச ஒப்பீடு",
    feature: "அம்சம்",
    benefits_500: "500+ பங்குதாரர் அழகு நிலையங்கள்",
    benefits_instant: "உடனடி செயல்படுத்தல்",
    benefits_cancel: "எந்த நேரத்திலும் ரத்து",
    benefits_refund: "7 நாள் பணத்திரும்பப் பெறல்",
    faq_title: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    faq_cancel_q: "என் உறுப்பினர் திட்டத்தை ரத்து செய்ய முடியுமா?",
    faq_cancel_a: "ஆம். உங்கள் டாஷ்போர்டிலிருந்து எந்த நேரத்திலும் ரத்து செய்யலாம். உங்கள் பில்லிங் காலத்தின் முடிவு வரை உங்கள் சலுகைகள் தொடரும்.",
    faq_all_salons_q: "தள்ளுபடி அனைத்து அழகு நிலையங்களுக்கும் பொருந்துமா?",
    faq_all_salons_a: "ஆம் — இந்தியா முழுவதும் உள்ள 500+ சரிபார்க்கப்பட்ட Fayriza பங்குதாரர் அழகு நிலையங்களில் தள்ளுபடி தானாகவே பொருந்தும்.",
    faq_refund_q: "7 நாள் பணத்திரும்பப் பெறும் உத்தரவாதம் என்றால் என்ன?",
    faq_refund_a: "செயல்படுத்தப்பட்ட 7 நாட்களுக்குள் நீங்கள் திருப்தி அடையவில்லை என்றால், உங்கள் உறுப்பினர் கட்டணத்தை முழுமையாகத் திருப்பி வழங்குவோம் — எந்த கேள்வியும் கேட்கப்படாது.",
    faq_upgrade_q: "என் திட்டத்தை மேம்படுத்த முடியுமா?",
    faq_upgrade_a: "ஆம். எந்த நேரத்திலும் மேம்படுத்தலாம். மீதமுள்ள காலத்திற்கான விகிதாசார வேறுபாடு உங்களிடம் வசூலிக்கப்படும்.",
    activated: "🎉 Fayriza {{plan}} செயல்படுத்தப்பட்டது!",
    subscribe_failed: "சந்தா தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
  },
  shop: {
    eyebrow: "Fayriza கடை",
    hero_title: "பிரீமியம் அழகு & அலங்கார பொருட்கள்",
    hero_sub: "தேர்ந்தெடுக்கப்பட்ட தொழில்முறை தரமான அத்தியாவசியங்கள், உங்கள் வீட்டு வாசலில் வழங்கப்படுகிறது.",
    search_placeholder: "பொருட்களைத் தேடுங்கள்…",
    categories: "வகைகள்",
    all_products: "அனைத்து பொருட்கள்",
    add_to_cart: "கார்ட்டில் சேர்",
    added: "சேர்க்கப்பட்டது ✓",
    out_of_stock: "கையிருப்பில் இல்லை",
    checkout: "செக்அவுட்",
    cart: "கார்ட்",
    cart_empty: "உங்கள் கார்ட் காலியாக உள்ளது",
    cart_empty_sub: "அதை நிரப்ப ஷாப்பிங் செய்யத் தொடங்குங்கள்",
    products: "பொருட்கள்",
    orders: "எனது ஆர்டர்கள்",
    no_orders: "இதுவரை ஆர்டர்கள் இல்லை",
    order_ref: "ஆர்டர் ஐடி",
    order_status: "நிலை",
    order_placed: "ஆர்டர் செய்யப்பட்டது",
    order_shipped: "அனுப்பப்பட்டது",
    order_delivered: "வழங்கப்பட்டது",
    order_cancelled: "ரத்து செய்யப்பட்டது",
    qty: "அளவு",
    remove: "அகற்று",
    subtotal: "துணை மொத்தம்",
    shipping: "அனுப்புகை",
    tax: "வரி",
    total: "மொத்தம்",
    proceed_checkout: "செக்அவுட்டிற்குச் செல்",
    shipping_address: "அனுப்புகை முகவரி",
    place_order: "ஆர்டர் செய்",
    continue_shopping: "ஷாப்பிங்கை தொடர்",
    product_details: "பொருள் விவரங்கள்",
    description: "விளக்கம்",
    specifications: "விவரக்குறிப்புகள்",
    you_may_like: "நீங்களும் இதை விரும்பலாம்",
    related: "தொடர்புடைய பொருட்கள்",
  },
  academy: {
    eyebrow: "Fayriza அகாடமி",
    hero_title: "இந்தியாவின் சிறந்த ஸ்டைலிஸ்டுகளிடமிருந்து கற்றுக்கொள்ளுங்கள்",
    hero_sub: "சான்றளிக்கப்பட்ட நிபுணர்களால் கற்பிக்கப்படும் தொழில்முறை அழகு & அலங்கார படிப்புகள். உங்கள் சொந்த வேகத்தில் கற்றுக்கொள்ளுங்கள், சான்றிதழ்களைப் பெறுங்கள், உங்கள் வாழ்க்கையைத் தொடங்குங்கள்.",
    search_placeholder: "படிப்புகள் அல்லது பயிற்றுவிப்பாளர்களைத் தேடுங்கள்…",
    stats_courses: "நிபுணர் படிப்புகள்",
    stats_students: "மாணவர்கள் சேர்ந்துள்ளனர்",
    stats_rating: "சராசரி மதிப்பீடு",
    stats_certificate: "சான்றிதழ் உள்ளடக்கியது",
    all: "அனைத்து படிப்புகள்",
    makeup: "மேக்கப்",
    hair: "முடி",
    skin: "தோல்",
    nails: "நகங்கள்",
    grooming: "அலங்காரம்",
    courses: "படிப்புகள்",
    course: "படிப்பு",
    enroll: "இப்போதே சேர்",
    enrolled: "சேர்ந்துவிட்டீர்கள்",
    modules: "தொகுதிகள்",
    instructor: "பயிற்றுவிப்பாளர்",
    duration: "கால அளவு",
    level: "நிலை",
    level_beginner: "ஆரம்ப நிலை",
    level_intermediate: "இடைநிலை",
    level_advanced: "மேம்பட்ட நிலை",
    certificate: "சான்றிதழ்",
    no_courses: "உங்கள் வடிகட்டிகளுக்கு பொருந்தும் படிப்புகள் இல்லை",
    my_enrollments: "எனது படிப்புகள்",
    continue_learning: "கற்றலைத் தொடர்",
    completed: "முடிக்கப்பட்டது",
  },
  notifications: {
    title: "அறிவிப்புகள்",
    empty: "எல்லாம் பார்த்துவிட்டீர்கள்",
    empty_sub: "இப்போது புதிய அறிவிப்புகள் இல்லை",
    mark_all_read: "அனைத்தையும் படித்ததாக குறிக்கவும்",
    just_now: "இப்போதே",
    minutes_ago: "{{n}} நிமிடம் முன்பு",
    hours_ago: "{{n}} மணி முன்பு",
    days_ago: "{{n}} நாள் முன்பு",
  },
  ai: {
    title: "Fayriza AI ஆலோசகர்",
    subtitle: "AI-இயக்கப்படும் தனிப்பயனாக்கப்பட்ட அழகு பரிந்துரைகள்.",
    placeholder: "தோல், முடி, மேக்கப் பற்றி எதையும் கேளுங்கள்…",
    send: "அனுப்பு",
    examples_title: "இவற்றைக் கேட்டுப் பாருங்கள்",
    ex_1: "என் முக வடிவத்திற்கு சிறந்த ஹேர்கட்?",
    ex_2: "எண்ணெய் தோலுக்கான தோல் பராமரிப்பு முறை",
    ex_3: "2026 மணப்பெண் மேக்கப் போக்குகள்",
    thinking: "யோசிக்கிறது…",
    disclaimer: "பரிந்துரைகள் தகவல் அடிப்படையிலானவை. மருத்துவ கவலைகளுக்கு, ஒரு நிபுணரை அணுகவும்.",
  },
  marketing: {
    about: {
      eyebrow: "எங்கள் கதை",
      title: "அழகு, மறு கற்பனையில்",
      sub: "Fayriza ஒரு எளிய எண்ணத்திலிருந்து பிறந்தது — இந்தியா அதன் கைவினைப்பொருள் போலவே மெருகூட்டப்பட்ட அழகு நிலைய முன்பதிவு அனுபவத்திற்கு தகுதியானது.",
      mission_title: "எங்கள் நோக்கம்",
      mission_body: "லட்சக்கணக்கான அழகு ஆர்வலர்களை இந்தியாவின் சிறந்த அழகு நிலையங்களுடன் தடையற்ற, நம்பகமான, ஆடம்பரமான தளம் மூலம் இணைப்பது.",
      vision_title: "எங்கள் தொலைநோக்கு",
      vision_body: "தரமான அழகு மற்றும் ஆரோக்கிய சேவைகள் அனைவருக்கும் விரல் நுனியில் கிடைக்கும் உலகம்.",
      values_title: "எங்கள் மதிப்புகள்",
      value_1_title: "தரம் முதலில்",
      value_1_body: "ஒவ்வொரு பங்குதாரர் அழகு நிலையமும் சரிபார்க்கப்பட்டு, எங்கள் பிரீமியம் தரத்திற்கு ஏற்ப பராமரிக்கப்படுகிறது.",
      value_2_title: "வாடிக்கையாளரே முதன்மை",
      value_2_body: "முன்பதிவு முதல் பின் பராமரிப்பு வரை — உங்கள் அனுபவமே எங்கள் துருவ நட்சத்திரம்.",
      value_3_title: "பங்குதாரர்களை வலுப்படுத்துதல்",
      value_3_body: "எங்கள் அழகு நிலையங்கள் மற்றும் ஸ்டைலிஸ்டுகள் வளரும்போது நாங்களும் வளர்கிறோம்.",
      cta_title: "கதையின் ஒரு பகுதியாக இருங்கள்",
      cta_sub: "இன்றே Fayriza சமூகத்தில் இணையுங்கள்.",
    },
    how_it_works: {
      eyebrow: "இது எப்படி செயல்படுகிறது",
      title: "மூன்று படிகளில் முன்பதிவு",
      sub: "யூகங்கள் இல்லாமல், பிரீமியம் அழகு.",
      step_1_title: "கண்டறி",
      step_1_body: "உங்களுக்கு அருகிலுள்ள சரிபார்க்கப்பட்ட அழகு நிலையங்கள், சேவைகள், ஸ்டைலிஸ்டுகளை உலாவுங்கள்.",
      step_2_title: "முன்பதிவு",
      step_2_body: "உங்களுக்கு ஏற்ற நேரத்தைத் தேர்ந்தெடுங்கள் — உடனடியாக உறுதி செய்யப்படுகிறது.",
      step_3_title: "ரசியுங்கள்",
      step_3_body: "மகிழ்ச்சியை அனுபவியுங்கள். உங்கள் வருகையை மதிப்பிடுங்கள். வெகுமதிகளைச் சம்பாதியுங்கள்.",
      faq_title: "விரைவு கேள்விகள்",
    },
    partners: {
      eyebrow: "அழகு நிலைய உரிமையாளர்களுக்கு",
      title: "Fayriza உடன் வளருங்கள்",
      sub: "புதிய வாடிக்கையாளர்களை அடையுங்கள், காலி நாற்காலிகளை நிரப்புங்கள், நவீன அழகு நிலையத்தை நடத்துங்கள்.",
      benefit_1_title: "அதிக வாடிக்கையாளர்கள்",
      benefit_1_body: "இந்தியாவின் மிகப்பெரிய பிரீமியம் அழகு பார்வையாளர்களை அணுகுங்கள்.",
      benefit_2_title: "ஸ்மார்ட் முன்பதிவு",
      benefit_2_body: "ஒரே டாஷ்போர்டிலிருந்து அட்டவணைகள், ஊழியர்கள், சேவைகளை நிர்வகிக்கவும்.",
      benefit_3_title: "உடனடி பணம் செலுத்துதல்",
      benefit_3_body: "பாதுகாப்பான, விரைவான பணம் வழங்கல் — கைமுறையாக வாங்கத் தேவையில்லை.",
      cta: "பங்குதாரராகுங்கள்",
    },
    stylists: {
      eyebrow: "ஸ்டைலிஸ்டுகளுக்கு",
      title: "உங்கள் வாடிக்கையாளர்களை உருவாக்குங்கள்",
      sub: "உங்கள் படைப்பைக் காட்டுங்கள், கண்டறியப்படுங்கள், உங்கள் வாழ்க்கையை வளர்த்துக்கொள்ளுங்கள்.",
      cta: "ஸ்டைலிஸ்டாக விண்ணப்பியுங்கள்",
    },
    careers: {
      eyebrow: "வேலை வாய்ப்புகள்",
      title: "அழகின் எதிர்காலத்தை வடிவமைக்கவும்",
      sub: "நாங்கள் பெரிய ஒன்றை உருவாக்கும் சிறு குழு. இணைய விரும்புகிறீர்களா?",
      openings_title: "திறந்த பதவிகள்",
      no_openings: "இப்போது திறந்த பதவிகள் இல்லை. careers@fayriza.com-இல் எங்களுக்கு ஒரு குறிப்பை அனுப்புங்கள்.",
    },
    contact: {
      eyebrow: "தொடர்பில் இருங்கள்",
      title: "உங்களிடமிருந்து கேட்க விரும்புகிறோம்",
      sub: "கேள்விகள், கருத்துக்கள் அல்லது கூட்டாண்மை யோசனைகள் — நாங்கள் எல்லாவற்றையும் கேட்கிறோம்.",
      name: "உங்கள் பெயர்",
      email: "உங்கள் மின்னஞ்சல்",
      message: "செய்தி",
      send: "செய்தி அனுப்பு",
      sent: "நன்றி — 24 மணி நேரத்திற்குள் உங்களைத் தொடர்புகொள்வோம்.",
      support_email: "ஆதரவு",
      partners_email: "பங்குதாரர்கள்",
      media_email: "ஊடகம்",
    },
    faq: {
      eyebrow: "உதவி",
      title: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
      sub: "பொதுவான கேள்விகளுக்கான விரைவான பதில்கள்.",
    },
    legal: {
      privacy_title: "தனியுரிமைக் கொள்கை",
      terms_title: "சேவை விதிமுறைகள்",
      refund_title: "பணத்திரும்பப் பெறும் கொள்கை",
      last_updated: "கடைசியாக புதுப்பிக்கப்பட்டது {{date}}",
    },
  },
  errors: {
    network: "நெட்வொர்க் பிழை — உங்கள் இணைப்பைச் சரிபார்க்கவும்",
    unauthorised: "தொடர உள்நுழையவும்",
    forbidden: "இதற்கு உங்களுக்கு அணுகல் இல்லை",
    not_found: "நீங்கள் தேடுவதைக் கண்டறிய முடியவில்லை",
    server: "சர்வர் பிழை — சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்",
    validation: "குறிக்கப்பட்ட புலங்களைச் சரிபார்க்கவும்",
    generic: "ஏதோ தவறு நடந்துள்ளது",
    page_not_found_title: "பக்கம் கிடைக்கவில்லை",
    page_not_found_sub: "நீங்கள் தேடும் பக்கம் நகர்த்தப்பட்டது அல்லது இனி இல்லை.",
    go_home: "முகப்புக்குச் செல்",
  },
};

export default ta;
